import { getUi } from '../queries/ui';

export default {
  Mutation: {
    updateUi: (parent: any, { input }: any, { cache }: any) => {
      const previous = cache.readQuery({ query: getUi });
      const newUi = { ...previous.getUi, ...input };

      cache.writeQuery({ query: getUi, data: { getUi: newUi } });

      return newUi;
    },
  },
  Query: {
    getUi: (parent: any, args: any, { cache }: any) => cache.data.getUi,
  },
};
